import { injectScope } from "@/utils/lang/util";
import type { Lang } from "@noli/core";

export enum Monkey_Words {
  "error-message" = "error-message",
  "balance-not-enough-message" = "balance-not-enough-message",
  "submit" = "submit",
  "cost" = "cost",
  "textarea-placeholder" = "textarea-placeholder",
  "creator-monkey-img2img-task" = "creator-monkey-img2img-task",
  "creator-monkey-task" = "creator-monkey-task",
}

injectScope("monkey", Monkey_Words);

// 要记得把这个 xxxLangRecords，引用到 src\thirdParty\lang.ts 中的 allThirdPartyLangRecords 里头

export const monkeyLangRecords: Record<Lang, Record<Monkey_Words, string>> = {
  zh: {
    [Monkey_Words["error-message"]]: "生成失败",
    [Monkey_Words["balance-not-enough-message"]]: "画力星余额不足",
    [Monkey_Words["submit"]]: "生成并添加",
    [Monkey_Words["cost"]]: "消耗 $ 画力星",
    [Monkey_Words["textarea-placeholder"]]:
      "输入文字，用 <IP> 代表提示词，例如输入“ 一张关于 <IP> 的图片”",
    [Monkey_Words["creator-monkey-task"]]: "文生图（大模型）",
    [Monkey_Words["creator-monkey-img2img-task"]]: "垫图生成（大模型）",
  },
  en: {
    [Monkey_Words["error-message"]]: "Generate failed",
    [Monkey_Words["balance-not-enough-message"]]: "Heart coin not enough",
    [Monkey_Words["submit"]]: "Generate & Add",
    [Monkey_Words["cost"]]: "With $ heart coins",
    [Monkey_Words["textarea-placeholder"]]:
      "Enter text, use <IP> represent prompt, e.g.: A picture about <IP>",
    [Monkey_Words["creator-monkey-task"]]: "Text to Image(InfMonkeys)",
    [Monkey_Words["creator-monkey-img2img-task"]]: "Image Translation(InfMonkeys)",
  },
};
